import React from 'react';
import StyledDateInterval from "core/components/fields/styledDateInterval";
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import NumberField from 'core/components/fields/numberField';
import {Validate} from 'core/form/validate';
import SvgDelete = require('react-icons/lib/md/delete');
import {MdIconButton} from "core/components/buttons/icons";
import {lovLabel, FieldText, FormProps, ClosedContentProps, lovValue} from 'core/form/formUtils';
import {formatInterval} from "core/common/utils/dateUtils";
import {PRICECOMPLEVEL_COLORS, PriceComponent, Vehicle} from "product/productDomain";
import {observer} from "mobx-react";
import Lens from "material-ui/svg-icons/image/lens";

@observer
class PriceComponentAssignedForm extends React.Component<FormProps<PriceComponent, Vehicle>, undefined> {

  onDelete = (e) => {
    this.props.onDelete(this.props.index);
  };

  render() {

    let {dataObject, rootObject, entities, entity, formName, open} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {price, priceCurrency, priceLcy, validFrom, validTo} = fields;


    return (
      <div className="row">
        <div style={{marginRight: 10, marginLeft: 5, alignSelf: 'center'}}>
          <Lens style={{color: (dataObject.priceLevel) ? PRICECOMPLEVEL_COLORS[lovValue(dataObject.priceLevel)] : PRICECOMPLEVEL_COLORS.PRODUCTVEHICLE}} />
        </div>
        <div className="fx col-xs-6 col-sm-2">
          <NumberField {...price.props} />
          <Validate field={price} value={price.props.value}/>
        </div>
        <div className="fx col-xs-6 col-sm-2">
          <StyledSelect {...priceCurrency.props} />
          <Validate field={priceCurrency} value={priceCurrency.props.value}/>
        </div>
        <div className="fx col-xs-6 col-sm-2">
          <NumberField {...priceLcy.props} />
          <Validate field={priceLcy} value={priceLcy.props.value}/>
        </div>
        <div className="col-xs-6 col-sm-4">
          <StyledDateInterval {...validFrom.props} valueFrom={validFrom.props.value} valueTo={validTo.props.value}
                              onChangeFrom={validFrom.props.onChange} onChangeTo={validTo.props.onChange} />
        </div>
        <MdIconButton style={{alignSelf: 'center'}} onClick={this.onDelete}>
          <SvgDelete size={24}/>
        </MdIconButton>
      </div>
    );


  }
}

const ClosedContent = ({dataObject, entity, entities, fields}: ClosedContentProps<PriceComponent>) => (
  <div>
    <div className="form-text-row">
      <span style={{marginRight: 5}}>{lovLabel(dataObject.product)}</span>
      <FieldText label={fields.price.textLabel} value={dataObject.price}  mdField={fields.price.mdField}/>
      <FieldText value={dataObject.priceCurrency}/>
      <FieldText label={fields.priceLcy.textLabel} value={dataObject.priceLcy}  mdField={fields.priceLcy.mdField}/>
    </div>
    <div className="form-text-row">
      <FieldText label={fields.validFrom.textLabel} value={formatInterval(dataObject.validFrom, dataObject.validTo)} />
    </div>
  </div>
);


const definition = {
  formName: 'PriceComponentAssignedForm',
  nested: true,
  fields: [{
    name: 'price',
    validators: ['IsRequired', 'IsNumber']
  }, {
    name: 'priceCurrency',
    validators: ['IsRequired']
  }, {
      name: 'priceLcy',
      validators: ['IsNumber']
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }]
};

export default createForm(definition, ClosedContent)(PriceComponentAssignedForm);




// WEBPACK FOOTER //
// ./src/product/component/priceComponentAssignedForm.tsx